module.exports = __webpack_public_path__ + "img/car-side.5f9ad3b4.svg";